import { CheckCircle2, Circle, Trash2, Edit2 } from "lucide-react";
import { format } from "date-fns";

const priorityColors = {
  high: "priority-badge-high",
  medium: "priority-badge-medium",
  low: "priority-badge-low",
};

export function TaskCard({ task, index, onToggle, onEdit, onDelete }) {
  return (
    <div
      className={`card-base p-4 flex items-start gap-4 animate-fade-in stagger-${
        (index % 6) + 1
      } ${task.completed ? "opacity-60" : ""}`}
      data-testid={`task-card-${task.id}`}
    >
      <button
        onClick={() => onToggle(task)}
        className="mt-1 text-slate-400 hover:text-indigo-400 transition-colors"
        data-testid={`toggle-task-${task.id}`}
      >
        {task.completed ? (
          <CheckCircle2 className="text-emerald-500" size={22} />
        ) : (
          <Circle size={22} />
        )}
      </button>

      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <h3
            className={`text-white font-medium ${
              task.completed ? "line-through text-slate-500" : ""
            }`}
          >
            {task.title}
          </h3>
          <span
            className={`px-2 py-0.5 rounded-full text-xs border ${
              priorityColors[task.priority]
            }`}
          >
            {task.priority}
          </span>
        </div>

        {task.description && (
          <p className="text-slate-400 text-sm mt-1 line-clamp-2">
            {task.description}
          </p>
        )}

        <div className="flex items-center gap-4 mt-2 text-xs text-slate-500">
          {task.assigned_to_name && (
            <span>Assigned to {task.assigned_to_name}</span>
          )}
          {task.due_date && (
            <span>Due {format(new Date(task.due_date), "MMM d")}</span>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={() => onEdit(task)}
          className="p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
          data-testid={`edit-task-${task.id}`}
        >
          <Edit2 size={16} />
        </button>
        <button
          onClick={() => onDelete(task.id)}
          className="p-2 text-slate-400 hover:text-red-400 hover:bg-slate-800 rounded-lg transition-colors"
          data-testid={`delete-task-${task.id}`}
        >
          <Trash2 size={16} />
        </button>
      </div>
    </div>
  );
}
